var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeaderEFTG',{ref:"headerEFTG",attrs:{"showAuth":false}}),_c('div',{staticClass:"container"},[_c('h2',{staticClass:"text-center mb-4"},[_vm._v("My portfolio")]),_c('AuthComponent',{ref:"auth",on:{"login":_vm.onLogin}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }